import { __assign } from "tslib";
import { extractField } from '@coherence-design-system/utilities';
import { mergeStyleSets } from '@fluentui/react';
import React from 'react';
import { extractData, valueOrDefaultColumnRenderer } from '../../Utilities';
import { DataGridColumnActions, DataGridColumnDate, DataGridColumnIconText, DataGridColumnLink, DataGridColumnNumber, DataGridColumnPersona, DataGridColumnStatus, DataGridColumnText } from './Components';
import { DataGridColumnBlank } from './Components/DataGridColumnBlank';
import { dataGridColumnStyle } from './DataGridColumn.styles';
export function DataGridColumn(props) {
    var _a;
    var data = props.data, column = props.column, theme = props.theme;
    var dataExtracted = extractData(data, column);
    var dataToRender = valueOrDefaultColumnRenderer(dataExtracted);
    var DEFAULT_EMPTY_VALUE = '--';
    var processedStyles = mergeStyleSets(dataGridColumnStyle(theme));
    var isCellValueInvalid = dataExtracted === undefined ||
        dataExtracted === null ||
        String(dataExtracted).length <= 0 ||
        dataToRender === DEFAULT_EMPTY_VALUE ||
        !data[column.fieldName] === undefined;
    if (column.type !== 'actions' && isCellValueInvalid) {
        return (React.createElement(DataGridColumnBlank, { dataGridColumnProcessedStyle: processedStyles, emptyColumnAriaLabel: column.emptyColumnAriaLabel, text: DEFAULT_EMPTY_VALUE, type: column.type }));
    }
    else {
        switch (column.type) {
            case 'number':
            case 'currency': {
                var DEFAULT_CODE = 'USD';
                return (React.createElement(DataGridColumnNumber, { className: column.className, value: extractData(data, column), dataGridColumnProcessedStyle: processedStyles, currencyCode: column.type === 'currency'
                        ? (_a = (column.currencyCode && extractField(data, column.currencyCode))) !== null && _a !== void 0 ? _a : DEFAULT_CODE : undefined }));
            }
            case 'date':
            case 'dayjs':
                return (React.createElement(DataGridColumnDate, { isOverdue: column.isOverdue && extractField(data, column.isOverdue), dataGridColumnProcessedStyle: processedStyles, overdueText: column.overdueText && extractField(data, column.overdueText), dayjsFormatter: column.dayjsFormatter, date: extractData(data, column), className: column.className }));
            case 'boolean':
            case 'string':
            case 'CrmLookUpType':
            case 'CrmOptionSet':
            case 'text':
            case 'primaryText':
                return (React.createElement(DataGridColumnText, { text: dataExtracted, dataGridColumnProcessedStyle: processedStyles, className: column.className, highlightText: column.highlightText, ariaLabel: column.ariaLabel }));
            case 'iconText':
                return (React.createElement(DataGridColumnIconText, { text: extractData(data, column), dataGridColumnProcessedStyle: processedStyles, icon: extractField(data, column.icon), className: column.className }));
            case 'status':
                return (React.createElement(DataGridColumnStatus, { text: extractData(data, column), dataGridColumnProcessedStyle: processedStyles, color: extractField(data, column.status), className: column.className, theme: theme }));
            case 'link':
            case 'secondaryLink': {
                var linkStyles = {
                    fontProperties: processedStyles.fontProperties,
                    linkColor: processedStyles.linkColor,
                    alignLeft: processedStyles.alignLeft
                };
                if (column.type === 'secondaryLink')
                    linkStyles.linkColor = processedStyles.secondaryLinkColor;
                return (React.createElement(DataGridColumnLink, __assign({}, column.linkProps, { text: extractData(data, column), dataGridColumnStyle: linkStyles, dataGridColumnProcessedStyle: {
                        leftAlignedCellContainer: processedStyles.leftAlignedCellContainer
                    }, href: extractField(data, column.url), className: column.className, highlightText: column.highlightText, ariaLabel: column.ariaLabel })));
            }
            case 'persona':
                return (React.createElement(DataGridColumnPersona, __assign({ fullName: extractData(data, column), dataGridColumnProcessedStyle: processedStyles, imageUrl: column.imageUrl && extractField(data, column.imageUrl), className: column.className, personaAlt: column.personaAlt }, column.personaProps)));
            case 'actions':
                return (React.createElement(DataGridColumnActions, { className: column.className, dataGridColumnProcessedStyle: processedStyles, menuActions: column.menuActions.map(function (x) { return (__assign(__assign({}, x), { onClick: function () { return x.onClick(data); } })); }), visibleActions: column.visibleActions.map(function (x) { return (__assign(__assign({}, x), { onClick: function () { return x.onClick(data); } })); }), menuActionsAriaLabel: column.menuActionsAriaLabel, menuActionsTooltip: column.menuActionsTooltip, theme: theme }));
            default:
                return null;
        }
    }
}
//# sourceMappingURL=DataGridColumn.js.map